<template lang="pug">
.el-container
  .el-card.el-card-margin-4.el-card-full-width.el-card-full-height-with-scroll(v-if='loading')
    i.el-icon-loading
    span &nbsp; {{loadingStatus}}
  .el-card.el-card-margin-4.el-card-full-width.el-card-full-height-with-scroll(v-if='!loading')
    el-header
      span.header-title-underlined
        el-input(id="GroupsHeader-searchInput", style="width:200px;", size="mini", v-model="searchString", clearable)
          i.el-icon-search.el-input__icon(slot='suffix')
      NaviButtons.float-right(:side="side", @reloadRightComponent='reloadRightComponent')
      hr.header
      .pagination-row(id="GroupsHeader-paginationRow")
        el-pagination.pagination(
          @size-change='handlePaginationSizeChange',
          @current-change='handlePaginationCurrentChange',
          :current-page.sync='currentPaginationPage',
          :page-sizes='[10, 20, 50, 100]',
          :page-size.sync='currentPaginationSize',
          background,
          layout='prev, pager, next, total, sizes',
          :total='searchString.length > startSearchAtStringLength ? desktopGroupsFiltered.length : desktopGroups.length'
        )
    GroupList(
      :desktopGroups='desktopGroupsFilteredAndPaginated',
      ref="Groups",
      @loadEditMediumInMediaEditor="loadEditMediumInMediaEditor",
      @reloadLeftComponent="reloadLeftComponent",
      @reloadRightComponent="reloadRightComponent",
      @rightClickAction='rightClickAction',
      @closeLeftPanelContextMenu='closeLeftPanelContextMenu'
    )
</template>

<script>
import Vue from 'vue'
import GroupList from './GroupList'
import NaviButtons from './NaviButtons'

export default {
  components: {
    GroupList,
    NaviButtons
  },
  props: ['side'],
  data () {
    return {
      errors: {
      },
      desktopGroup: {},
      isSaving: false,
      loading: false,
      loadingStatus: this.$t('Getting Groups'),
      desktopGroups: [],
      currentPaginationPage: 1,
      currentPaginationSize: 10,
      subscribeTimeoutPointer: undefined,
      subscribeTimeoutMs: 2000,
      startSearchAtStringLength: 2
    }
  },
  async created () {
    await this.loadData()
    this.subscribeToDesktops()
  },
  watch: {
    desktopGroupsFilteredAndPaginated: function (newVal, oldVal) {
      if (this.subscribeTimeoutPointer) clearTimeout(this.subscribeTimeoutPointer)
      this.subscribeTimeoutPointer = setTimeout(() => {
        this.subscribeToDesktops()
      }, this.subscribeTimeoutMs)
    }
  },
  methods: {
    closeLeftPanelContextMenu () {
      this.$emit('closeLeftPanelContextMenu')
    },
    closeRightClickMenu () {
      this.$refs['Groups'].closeRightClickMenu()
      for (const $desktop of this.$refs['Groups'].$children) {
        if ($desktop.closeRightClickDesktopMenu) $desktop.closeRightClickDesktopMenu()
      }
    },
    rightClickAction (data) {
      this.$emit('rightClickAction', data)
    },
    reloadLeftComponent () {
      this.$emit('reloadLeftComponent')
    },
    reloadRightComponent () {
      this.$emit('reloadRightComponent')
    },
    subscribeToDesktops () {
      let desktops = []
      for (const desktopGroup of this.desktopGroupsFilteredAndPaginated) {
        desktops = desktops.concat(desktopGroup.DeviceDesktops)
      }
      Vue.$io.socket.post('/deviceDesktop/subscribeToDesktops', {
        ids: desktops.map(dt => dt.id)
      })
      Vue.$io.socket.off('devicedesktop')
      Vue.$io.socket.on('devicedesktop', (devicedesktop) => {
        if (!this.$store.state.User.liveMode.heartbeat) return
        this.$store.dispatch('Device/updateDesktop', devicedesktop)
      })
      Vue.$io.socket.off('screenshot_collected')
      Vue.$io.socket.on('screenshot_collected', desktop => {
        if (!this.$store.state.User.liveMode.screenshots) return
        this.$store.dispatch('Device/updateDesktop', desktop)
      })
    },
    handlePaginationSizeChange (val) {
      this.currentPaginationSize = val
      this.$store.dispatch('Device/paginationSetLimitGroups', [this.side, val])
    },
    handlePaginationCurrentChange (val) {
      this.currentPaginationPage = val
      this.$store.dispatch('Device/paginationSetPageGroups', [this.side, val])
    },
    async __validateInput () {
      this.errors = []
      if (!this.desktopGroup.name || this.desktopGroup.name.length < 1) {
        this.errors.push(this.$t('Please provide proper name of the Group'))
      }
      let path = `DeviceDesktopGroup?name=${this.desktopGroup.name}`
      const groupExists = await Vue.axios.get(path)
        .then(response => {
          if (response.data.length !== 0) return true
          return false
        })
      if (groupExists) {
        this.errors.push(this.$t('Group with this name already exists'))
      }
      if (this.errors.length > 0) return false
      this.errors = []
      return true
    },
    async addDesktopGroup () {
      const valid = await this.__validateInput()
      if (!valid) return
      this.isSaving = true
      await Vue.axios.post('DeviceDesktopGroup', this.desktopGroup)
        .then(response => {
          this.reloadData()
        })
      this.isSaving = false
    },
    async reloadData () {
      console.log('reloadData for groups')
      await this.loadData()
    },
    async loadData () {
      this.loading = true
      this.currentPaginationPage = this.$store.state.Device.pagination_groups[this.side].page
      this.currentPaginationSize = this.$store.state.Device.pagination_groups[this.side].limit
      await Vue.axios.get('DeviceDesktopGroup/list')
        .then(response => {
          this.desktopGroups = response.data
        })
      this.loading = false
    },
    loadEditMediumInMediaEditor (medium) {
      this.$emit('loadEditMediumInMediaEditor', medium)
    }
  },
  computed: {
    deviceTagFilterHidden () {
      return !this.$store.state.Device.show_tag_filter
    },
    desktopGroupsFiltered () {
      let groups = JSON.parse(JSON.stringify(this.desktopGroups))
      if (this.searchString.length > this.startSearchAtStringLength) {
        groups = groups.filter((desktopgroup) => {
          return desktopgroup.name.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1 || desktopgroup.address.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1
        })
      }
      return groups
    },
    desktopGroupsFilteredAndPaginated () {
      let groups = this.desktopGroupsFiltered
      const offset =
        (this.$store.state.Device.pagination_groups[this.side].page - 1) *
        this.$store.state.Device.pagination_groups[this.side].limit
      groups.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      return groups.slice(
        offset,
        offset + this.$store.state.Device.pagination_groups[this.side].limit
      )
    },
    searchString: {
      get () {
        return this.$store.state.Device.search_by_string
      },
      set (value) {
        this.$store.dispatch('Device/paginationSetPage', [ this.side, 1 ])
        this.$store.commit('Device/UPDATE_SEARCH_STRING', value)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.pagination-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 0px solid red;
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Device/GroupsHeader.vue